<div class="details-wrap content-wrap">
    <ng-container *ngIf="pageData !== null">
        <div class="detail-line" [@enter]>
            <div innerHTML="{{'__COACHING_DESCRIPTION__' | translate }}"></div>
            <div><strong>{{"__COACHING_RATING__" | translate }}</strong></div>
        </div>

        <div *ngFor="let group of pageData.groups; let i = index;">
            <div class="blue-line" [ngStyle]="group.style"
                 [@leave]>
                {{group.title}}
            </div>
            <div class="lines">
                <div *ngFor="let question of group.questions; let j = index;" class="line"
                     [@leave]>
                    <div class="text grid-col grid-col-1">{{question.title}}</div>
                    <div class="number grid-col grid-col-2"
                         [ngClass]="question.output.style.class">{{question.output.value}}</div>
                </div>
            </div>
        </div>
        <app-dropdown *ngIf="pageData.type === 'OTHERS'" [title]="'__COACHING_MANAGER_COMMENTS__' | translate" [opened]="true" text="{{pageData.comment}}"></app-dropdown>
        <app-dropdown *ngIf="pageData.type === 'SELF'" [title]="'__COACHING_SELF_COMMENT_ONE__' | translate" [opened]="true" text="{{pageData.comment_self_1}}"></app-dropdown>
        <app-dropdown *ngIf="pageData.type === 'SELF'" [title]="'__COACHING_SELF_COMMENT_TWO__' | translate" [opened]="true" text="{{pageData.comment_self_2}}"></app-dropdown>
        <app-dropdown *ngIf="pageData.type === 'SELF'" [title]="'__COACHING_SELF_COMMENT_THREE__' | translate" [opened]="true" text="{{pageData.comment_self_3}}"></app-dropdown>
    </ng-container>

    <ng-container *ngIf="pageData === null">
        <div class="detail-line">
            <div><ion-skeleton-text animated style="width: 70%;"></ion-skeleton-text></div>
            <div style="display: flex; justify-content: center;"><ion-skeleton-text animated style="width: 3rem;"></ion-skeleton-text></div>
        </div>

        <div *ngFor="let group of [1,2,3]">
            <div class="blue-line" style="background-color: #eeeeee">
            </div>
            <div class="lines">
                <div *ngFor="let width of ['80%','90%','50%','70%','60%']" class="line">
                    <div class="text grid-col grid-col-1"><ion-skeleton-text animated [ngStyle]="{width: width}"></ion-skeleton-text></div>
                    <div class="number grid-col grid-col-2"><ion-skeleton-text animated style="width: 50%;"></ion-skeleton-text></div>
                </div>
            </div>
        </div>
    </ng-container>
</div>


